<div class="flex flex-col lg:flex-row gap-6 p-4 md:p-6 bg-slate-100 min-h-screen relative" (click)="activeEditor = null">
  
  <!-- Sidebar Controls -->
  <div class="w-full lg:w-[700px] bg-white p-6 rounded-2xl shadow-xl border border-gray-200 h-fit lg:sticky lg:top-6 z-20">

    <button (click)="goBack()" class="flex items-center gap-2 text-gray-400 hover:text-[#c19725] transition mb-4 group">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 transform group-hover:-translate-x-1 transition" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
    </svg>
    <span class="text-[10px] font-black uppercase tracking-[0.2em]">Back to Dashboard</span>
  </button>

    <div class="flex items-center gap-3 mb-6">
      <div class="w-2 h-8 bg-[#c19725] rounded-full"></div>
      <h2 class="text-xl font-black text-gray-800 uppercase tracking-tight">GST Invoice Design</h2>
    </div>
    
    <div class="space-y-6">
      <div class="grid grid-cols-2 gap-3">
        <button (click)="triggerUpload('logoInput')" class="flex flex-col items-center p-4 border-2 border-dashed border-gray-200 rounded-2xl hover:border-[#c19725] hover:bg-yellow-50 transition group">
            <span class="text-2xl group-hover:scale-110 transition">🖼️</span>
            <span class="text-[10px] font-black text-gray-400 mt-2 uppercase">Brand Logo</span>
            <input type="file" id="logoInput" hidden (change)="onFileSelected($event, 'logo')">
        </button>
        <button (click)="triggerUpload('signInput')" class="flex flex-col items-center p-4 border-2 border-dashed border-gray-200 rounded-2xl hover:border-[#c19725] hover:bg-yellow-50 transition group">
            <span class="text-2xl group-hover:scale-110 transition">✍️</span>
            <span class="text-[10px] font-black text-gray-400 mt-2 uppercase">Sign Asset (Optional)</span>
            <input type="file" id="signInput" hidden (change)="onFileSelected($event, 'signature')">
        </button>
      </div>

      <div class="bg-gray-50 p-5 rounded-2xl space-y-4">
        <p class="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Global Colors</p>
        <div class="flex items-center justify-between">
            <label class="text-sm font-bold text-gray-700">Teal Theme</label>
            <input type="color" [(ngModel)]="invoiceSettings.colors.themeColor" class="w-10 h-8 rounded border-none cursor-pointer">
        </div>
        <div class="flex items-center justify-between">
            <label class="text-sm font-bold text-gray-700">Outer Frame</label>
            <input type="color" [(ngModel)]="invoiceSettings.colors.outerBorder" class="w-10 h-8 rounded border-none cursor-pointer">
        </div>
        <div class="flex items-center justify-between border-t pt-2">
            <label class="text-sm font-bold text-gray-700">Grand Total BG</label>
            <input type="color" [(ngModel)]="invoiceSettings.summary.grandTotal.backgroundColor" 
                   class="w-10 h-8 rounded border-none cursor-pointer">
        </div>
      </div>

      <div class="pt-2 space-y-3">
        <button (click)="saveLayoutSettings()" class="w-full py-4 bg-[#c19725] text-white rounded-2xl font-black shadow-lg hover:bg-[#a68220] transition active:scale-95">
          SAVE GST LAYOUT
        </button>
        <button (click)="resetLayoutSettings()" class="w-full py-3 text-gray-400 font-bold hover:bg-gray-100 rounded-xl transition">
          Reset to Default
        </button>
      </div>
    </div>
  </div>

  <!-- Real-Time Invoice Preview (Exact Match to Image) -->
  <div class="flex-1 lg:max-h-[calc(100vh-48px)] lg:overflow-y-auto scrollbar-hide">
    
    <!-- CONTEXTUAL EDITOR POPUP -->
    <div *ngIf="activeEditor" [ngStyle]="editorPosition" class="fixed z-[100] bg-white p-5 shadow-2xl border border-gray-100 rounded-2xl w-72 animate-in fade-in zoom-in duration-150" (click)="$event.stopPropagation()">
      <div class="flex justify-between items-center mb-4 border-b pb-2">
        <h4 class="text-[10px] font-black uppercase text-[#c19725] tracking-widest">{{ activeEditorLabel }}</h4>
        <button (click)="activeEditor = null" class="text-gray-300 hover:text-red-500 transition">✕</button>
      </div>
      <div class="space-y-4">
        <div *ngIf="activeEditor.text !== undefined">
          <label class="text-[9px] font-bold text-gray-400 uppercase block mb-1">Text Value</label>
          <input [(ngModel)]="activeEditor.text" class="w-full border rounded-xl p-2.5 text-xs outline-none focus:ring-1 focus:ring-[#c19725]">
        </div>
        <div class="flex justify-between items-center bg-gray-50 p-2.5 rounded-xl">
          <label class="text-[9px] font-bold text-gray-500 uppercase">Visibility</label>
          <input type="checkbox" [(ngModel)]="activeEditor.visible" class="accent-[#c19725] w-4 h-4">
        </div>
        <div *ngIf="activeEditor.color" class="flex justify-between items-center">
          <label class="text-[9px] font-bold text-gray-500 uppercase">Color</label>
          <input type="color" [(ngModel)]="activeEditor.color" class="w-7 h-7 rounded-full border-none cursor-pointer">
        </div>
      </div>
    </div>

    <!-- The Invoice Mockup (A4 Ratio) -->
    <div class="bg-white p-4 md:p-8 shadow-2xl mx-auto min-h-[1123px] h-fit min-w-[800px] lg:min-w-0 overflow-x-auto transition-all" [style.border]="'10px solid ' + invoiceSettings.colors.outerBorder">
      <div class="border border-black flex flex-col h-full min-h-[1050px] bg-white font-sans relative">
        
        <!-- Top Strip -->
        <div class="flex justify-between px-6 py-2 border-b border-black text-[11px] font-bold">
          <span class="cursor-pointer hover:bg-yellow-50 px-1" (click)="openEditor(invoiceSettings.header.gstin, 'GSTIN Label', $event)" [style.color]="invoiceSettings.header.gstin.color">{{invoiceSettings.header.gstin.text}}</span>
          <span class="cursor-pointer hover:bg-yellow-50 px-1 uppercase" (click)="openEditor(invoiceSettings.header.taxInvoice, 'Header Label', $event)" [style.color]="invoiceSettings.header.taxInvoice.color">{{invoiceSettings.header.taxInvoice.text}}</span>
        </div>

        <!-- Branding Section -->
        <div class="relative px-8 py-6 border-b border-black text-center group">
          <div (click)="triggerUpload('logoInput')" class="absolute left-8 top-6 h-20 w-20 cursor-pointer overflow-hidden border border-transparent hover:border-dashed hover:border-[#c19725] rounded transition">
              <img *ngIf="invoiceSettings.header.logo.visible" [src]="invoiceSettings.header.logo.url" class="h-full w-full object-contain">
              <div class="absolute inset-0 bg-black/5 opacity-0 group-hover:opacity-100 flex items-center justify-center text-[8px] font-bold text-[#c19725] uppercase bg-white/80">Change</div>
          </div>
          <h1 class="font-bold uppercase cursor-pointer hover:bg-yellow-50" (click)="openEditor(invoiceSettings.header.firmTitle, 'Main Title', $event)" [style.color]="invoiceSettings.header.firmTitle.color" [style.fontSize.px]="invoiceSettings.header.firmTitle.fontSize">{{invoiceSettings.header.firmTitle.text}}</h1>
          <p class="text-xs text-gray-500 cursor-pointer hover:bg-yellow-50" (click)="openEditor(invoiceSettings.header.address, 'Address', $event)">{{invoiceSettings.header.address.text}}</p>
          <div class="flex justify-center gap-6 mt-2 font-bold text-xs uppercase">
             <span (click)="openEditor(invoiceSettings.header.pan, 'PAN label', $event)" class="cursor-pointer hover:bg-yellow-50 px-1" [style.color]="invoiceSettings.header.pan.color">{{invoiceSettings.header.pan.text}}</span>
             <span (click)="openEditor(invoiceSettings.header.mobile, 'Mob label', $event)" class="cursor-pointer hover:bg-yellow-50 px-1" [style.color]="invoiceSettings.header.mobile.color">{{invoiceSettings.header.mobile.text}}</span>
          </div>
        </div>

        <!-- Details Grid -->
        <div class="grid grid-cols-2 border-b border-black text-[12px]">
          <div class="border-r border-black p-5">
            <h2 class="italic font-bold underline mb-2 cursor-pointer hover:bg-yellow-50" (click)="openEditor(invoiceSettings.detailsLabels.partyDetails, 'Party Header', $event)">{{invoiceSettings.detailsLabels.partyDetails.text}}</h2>
            <div class="font-bold text-lg text-black uppercase cursor-pointer hover:bg-yellow-50" (click)="openEditor(invoiceSettings.detailsLabels.customerName, 'Customer Label', $event)">{{invoiceSettings.detailsLabels.customerName.text}}</div>
            <p class="text-slate-400 cursor-pointer hover:bg-yellow-50" (click)="openEditor(invoiceSettings.detailsLabels.customerAddress, 'Address Label', $event)">{{invoiceSettings.detailsLabels.customerAddress.text}}</p>
            <p class="mt-4" *ngIf="invoiceSettings.detailsLabels.gstinUin.visible">
                <strong class="cursor-pointer hover:bg-yellow-50" (click)="openEditor(invoiceSettings.detailsLabels.gstinUin, 'GSTIN Label', $event)">{{invoiceSettings.detailsLabels.gstinUin.text}}</strong> N/A
            </p>
          </div>
          <div class="p-5 grid grid-cols-[130px_1fr] gap-y-1 content-center">
            <ng-container *ngFor="let item of [
              { key: 'invoiceNo', val: 'MS-00001' },
              { key: 'dated', val: '29 - JAN - 2026' },
              { key: 'modeOfPay', val: '' },
              { key: 'partyMobile', val: '' },
              { key: 'reverseCharge', val: 'No' },
              { key: 'placeOfSupply', val: '' }
            ]">
              <strong *ngIf="invoiceSettings.detailsLabels[item.key].visible" class="cursor-pointer hover:bg-yellow-50" (click)="openEditor(invoiceSettings.detailsLabels[item.key], 'Field Label', $event)" [style.color]="invoiceSettings.detailsLabels[item.key].color">{{invoiceSettings.detailsLabels[item.key].text}}</strong>
              <span *ngIf="invoiceSettings.detailsLabels[item.key].visible">: {{item.val}}</span>
            </ng-container>
          </div>
        </div>

        <!-- Table Structure -->
        <table class="w-full border-collapse">
          <thead [style.backgroundColor]="invoiceSettings.colors.themeColor" class="text-white text-[11px] uppercase tracking-wider">
            <tr>
              <th *ngFor="let h of invoiceSettings.table.headers" class="border-r border-white/20 p-3 italic font-semibold cursor-pointer hover:bg-black/10" (click)="openEditor(h, 'Table Header', $event)">{{h.text}}</th>
            </tr>
          </thead>
          <tbody class="text-sm">
            <tr class="h-14 border-b border-black/5">
              <td class="border-r border-black text-center text-gray-400 w-12">1.</td>
              <td class="border-r border-black px-4 italic font-bold text-base">{{invoiceSettings.table.sampleItem.text}}</td>
              <td class="border-r border-black text-center w-24">711311</td>
              <td class="border-r border-black text-center font-bold text-lg w-32">0.0000</td>
              <td class="border-r border-black text-center w-28"></td>
              <td class="text-right px-4 font-bold text-lg w-32">0</td>
            </tr>
            <tr class="h-10 border-b border-black/5"><td></td><td></td><td></td><td></td><td></td><td></td></tr>
          </tbody>

          <!-- Summary Section (Exact Rows from Image) -->
          <tfoot class="bg-white border-t border-black text-[13px]">
            <!-- Taxable Amount Row -->
            <tr class="border-b border-black/5" *ngIf="invoiceSettings.summary.taxableAmount.visible">
              <td colspan="5" class="text-right px-6 py-2 font-bold cursor-pointer hover:bg-yellow-50" (click)="openEditor(invoiceSettings.summary.taxableAmount, 'Taxable label', $event)">{{invoiceSettings.summary.taxableAmount.text}}</td>
              <td class="text-right px-4 font-bold">₹ 0</td>
            </tr>
            <!-- CGST Row -->
            <tr class="border-b border-black/5" *ngIf="invoiceSettings.summary.cgst.visible">
              <td colspan="5" class="text-right px-6 py-2 italic text-slate-400 cursor-pointer hover:bg-yellow-50" (click)="openEditor(invoiceSettings.summary.cgst, 'CGST label', $event)">{{invoiceSettings.summary.cgst.text}}</td>
              <td class="text-right px-4">0</td>
            </tr>
            <!-- SGST Row -->
            <tr class="border-b border-black/5" *ngIf="invoiceSettings.summary.sgst.visible">
              <td colspan="5" class="text-right px-6 py-2 italic text-slate-400 cursor-pointer hover:bg-yellow-50" (click)="openEditor(invoiceSettings.summary.sgst, 'SGST label', $event)">{{invoiceSettings.summary.sgst.text}}</td>
              <td class="text-right px-4">0</td>
            </tr>
            <!-- TOTAL Row -->
            <tr class="border-b border-black border-t" *ngIf="invoiceSettings.summary.total.visible">
              <td colspan="5" class="text-right px-6 py-2 font-black cursor-pointer hover:bg-yellow-50" (click)="openEditor(invoiceSettings.summary.total, 'Total label', $event)">{{invoiceSettings.summary.total.text}}</td>
              <td class="text-right px-4 font-bold">₹ 0</td>
            </tr>
            <!-- Adjustment Row -->
            <tr class="border-b border-black/5" *ngIf="invoiceSettings.summary.adjustment.visible">
              <td colspan="5" class="text-right px-6 py-2 text-slate-400 cursor-pointer hover:bg-yellow-50" (click)="openEditor(invoiceSettings.summary.adjustment, 'Adjustment label', $event)">{{invoiceSettings.summary.adjustment.text}}</td>
              <td class="text-right px-4 font-bold text-green-600">+ 0.00</td>
            </tr>
            <!-- GRAND TOTAL Section -->
            <tr class="border-t-2 border-black" [style.backgroundColor]="invoiceSettings.summary.grandTotal.backgroundColor">
              <td colspan="5" class="text-right px-6 py-4 text-2xl font-black uppercase cursor-pointer hover:bg-black/5" (click)="openEditor(invoiceSettings.summary.grandTotal, 'Grand Total Label', $event)" [style.color]="invoiceSettings.summary.grandTotal.color">{{invoiceSettings.summary.grandTotal.text}}</td>
              <td class="text-right text-3xl font-black px-4 border-l border-black/10" [style.color]="invoiceSettings.summary.grandTotal.color">₹</td>
            </tr>
          </tfoot>
        </table>

        <!-- Footer Section -->
        <div class="grid grid-cols-2 border-t border-black mt-auto bg-white">
          <div class="border-r border-black p-5 text-[10px]">
            <h4 class="font-bold underline mb-1 cursor-pointer hover:bg-yellow-50 uppercase tracking-wider" 
                (click)="openEditor(invoiceSettings.footer.termsTitle, 'Terms Title', $event)" 
                [style.color]="invoiceSettings.footer.termsTitle.color">
                {{invoiceSettings.footer.termsTitle.text}}
            </h4>
            
            <div class="space-y-1">
              <div *ngFor="let term of invoiceSettings.footer.termsList; let i = index" 
                   class="cursor-pointer hover:bg-yellow-50 px-1"
                   [class.hidden]="!term.visible"
                   (click)="openEditor(term, 'Term Line ' + (i+1), $event)">
                {{ term.text }}
              </div>
            </div>
          </div>
          <div class="flex flex-col justify-between p-5 text-center group">
            <p class="font-bold text-base cursor-pointer hover:bg-yellow-50" (click)="openEditor(invoiceSettings.footer.forFirm, 'Firm Name', $event)" [style.color]="invoiceSettings.footer.forFirm.color">{{invoiceSettings.footer.forFirm.text}}</p>
            <div class="h-20 flex items-center justify-center relative group">

                <!-- SIGNATURE IMAGE -->
                <img
                  *ngIf="invoiceSettings.footer.signature.url && invoiceSettings.footer.signature.visible"
                  [src]="invoiceSettings.footer.signature.url"
                  class="h-full object-contain cursor-pointer"
                  (click)="triggerUpload('signInput')"
                />
                          
                <!-- PLACEHOLDER -->
                <div
                  *ngIf="!invoiceSettings.footer.signature.url"
                  (click)="triggerUpload('signInput')"
                  class="w-full border-t border-dotted border-gray-400 cursor-pointer">
                </div>
              
                <!-- ❌ REMOVE BUTTON -->
                <button
                  *ngIf="invoiceSettings.footer.signature.url"
                  (click)="removeSignature($event)"
                  class="absolute -top-2 -right-2 bg-red-500 text-white w-6 h-6 rounded-full text-xs font-bold opacity-0 group-hover:opacity-100 transition">
                  ✕
                </button>
              
              </div>

            <p class="pt-2 font-bold uppercase text-[10px] tracking-widest text-slate-400 cursor-pointer hover:bg-yellow-50" (click)="openEditor(invoiceSettings.footer.signatory, 'Sign label', $event)">{{invoiceSettings.footer.signatory.text}}</p>
          </div>
        </div>

        <!-- Bank Stripe -->
        <div class="p-3 text-center text-white font-bold tracking-[0.05em] uppercase text-[10px] cursor-pointer hover:bg-black/10" [style.backgroundColor]="invoiceSettings.colors.themeColor" (click)="openEditor(invoiceSettings.footer.bankInfo, 'Bank details', $event)">
          {{invoiceSettings.footer.bankInfo.text}}
        </div>
      </div>
    </div>
  </div>
</div>